import { err, ok, type Result } from "neverthrow";
import type { z, ZodError, ZodSchema } from "zod";

export interface ZodParseError<T> {
  type: "zod";
  error: ZodError<T>;
}

// oxlint-disable-next-line no-explicit-any
export function safeZodParse<TSchema extends ZodSchema<any>>(
  schema: TSchema,
): (
  data: unknown,
) => Result<z.infer<TSchema>, ZodParseError<z.infer<TSchema>>> {
  return (data: unknown) => {
    const result = schema.safeParse(data);

    return result.success
      ? ok(result.data)
      : err({
          type: "zod",
          error: result.error,
        });
  };
}
